import { autoinject, LogManager, bindable } from 'aurelia-framework';
import { EntityController } from 'pages/entity/entity-controller';
import { ChildItemInfo } from 'data/entities/entities';
import { ChildItemInfoService } from 'data/service/child-item-info-service';
import { MetadataService } from 'data/service/meta-data-service';

@autoinject()
export class DashboardItemGrid {	
	pageSettings = { pageSize: 15, pageSizeList: [20, 25, 30] }
	scrollSettings = { width: "auto", height: "auto"};
	dropdown = 'dropdown';
	datetimepicker = ej.Grid.EditingType.DateTimePicker;
	datePicker = ej.Grid.EditingType.DatePicker;
	numeric = ej.Grid.EditingType.Numeric;
	editboolean = ej.Grid.EditingType.Boolean;
	numericEditParameters = { minValue: 0 };
	progressValidation = { range: [0, 100] }
	minBudgetAndCost = { min: 0 };
	edit = { allowEditing: true, editMode: ej.Grid.EditMode.Normal, allowAdding: true };
	toolbar = { showToolbar: true, toolbarItems: ['edit', 'update', 'cancel', 'add' ] };
	controlReference;
	@bindable tasks: Array<ChildItemInfo>;
	@bindable allow = false;
	@bindable parent;
	filtertype = { filterType: 'menu' };
	logger = LogManager.getLogger('ItemGrid');

	navigateTo(id) {
		(window as any).location = `#/app/explorer/entity/${id}`;
	}

	isRequired = { required: true };
	onActionComplete(event) {
		const requestType = event.requestType;
		if (requestType === "save") {
			const updated: ChildItemInfo = event.rowData;
			if (updated.id) {
				const existing = this.tasks.find(a => a.id === updated.id);
				this.saveItem(existing);
			}
			else {
				const newItem = this.tasks[0];
				this.saveNewItem(newItem);
			}
		}
		if (requestType === "add") {
			const newItem: ChildItemInfo = event.rowData;
			newItem.itemStatusId = 1;
		}
		this.logger.info(`onActionComplete() - ${requestType}`);
	}

	async getItemStatusColor(itemId) {
		console.log(itemId);
	}

	async saveNewItem(newItem) {
		//let existing = this.tasks[0];
		if (this.parent) {
			newItem.parentId = this.parent.id;
		}
		const savedItem = await this.childItemInfoService.save(newItem);
		newItem.id = savedItem.id;
		newItem.folderName = savedItem.folderName;
		this.logger.info(savedItem);
	}

	async saveItem(updated) {
		const savedItem = await this.childItemInfoService.save(updated);
		this.logger.info(savedItem);
	}

	onRowDrop(detail: { data: Array<ChildItemInfo>, target: any }) {
		this.logger.info("onRowDrop()");
		const droppedRow = detail.data[0];
		const grid = $("#taskGrid").ejGrid("instance");// take the Grid instance using Grid ID
		if (grid) {
			const droppedOnRow = grid.getCurrentViewData()[detail.target.closest("tr").index()]; // get row details using index of target element's closest tr 
			if (droppedOnRow && droppedRow && (droppedOnRow.id != droppedRow.id)) {
				this.controller.moveItemTo(droppedOnRow.id, droppedRow.id);
			}
		}
	}

	constructor(private controller: EntityController,
		private childItemInfoService: ChildItemInfoService,
		private metaDataService: MetadataService
	) {
		this.logger.info('metadataservice: ' + this.metaDataService.isInitialized);

		const customcompare1 = (value, element, params) => {
			const dueDateReference = "#" + this.controlReference.id + "dueDate";
			const dueDate = $(dueDateReference).attr("value");
			//Do not validate if either are empty.
			if (!element.value || !dueDate) return true;
			if (new Date(dueDate) >= new Date(element.value)) {
				return true;
			}
			else {
				return false;
			}
		};

		const customcompare2 = (value, element, params) => {		
			const startDateReference = "#" + this.controlReference.id + "startDate";
			const startDate = $(startDateReference).attr("value");
			//Do not validate if either are empty.
			if (!element.value || !startDate) return true;
			if (new Date(startDate) <= new Date(element.value)) {
				return true;
			}
			else {
				return false;
			}
		};
		($ as any).validator.addMethod('customcompare1', customcompare1, 'Start Date must be smaller than Due Date');
		($ as any).validator.addMethod('customcompare2', customcompare2, 'Due Date must be greater than Start Date');
	}

	tagEditTemplate = {
		create: function () {
			return "<input>";
		},
		read: function (args) {
			return "Test data";
		},
		write: function (args) {
			const val = ej.isNullOrUndefined(args.rowdata["tagList"]) ? "" : args.rowdata["tagList"];
			args.element.ejAutocomplete({
				dataSource: args.column[14].dataSource,
				showPopupButton: true,
				enableAutoFill: true,
				fields: { text: "name", key: "id" },
				width: "100%",
				value: args.rowdata !== undefined ? args.rowdata["tagList"] : ""
			}).ejAutocomplete("selectValueByKey", val);
		}
	};
}

